const organizations = '/organizations'
const users = '/users'

export const Collections = {
  Organizations: {
    Base: organizations,
    id: (organizationId: string) => `${Collections.Organizations.Base}/${organizationId}`,
    members: (organizationId: string) =>
      `${organizations}/${organizationId}/members`,
  },
  OrganizationsInvitations: '/organizations-invitations',
  Users: {
    Base: users,
    Organizations: {
      base: (userId: string) => `${users}/${userId}/organizations`,
      workspaces: (userId: string, organizationId: string) =>
        `${users}/${userId}/organizations/${organizationId}/workspaces`,
    },
  },
  Workspaces: {
    base: (organizationId: string) =>
      `${organizations}/${organizationId}/workspaces`,
    members: (organizationId: string, workspaceId: string) =>
      `${Collections.Workspaces.base(organizationId)}/${workspaceId}/members`,
  },
  Mail: '/mail',
}
